/** True when running Vite dev server or on localhost — never for deployed builds by hostname alone. */
export function isLocalDev(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return (
    import.meta.env.DEV === true ||
    host === 'localhost' ||
    host === '127.0.0.1'
  );
}
